import React from 'react'
import { Skeleton } from '../ui/skeleton'

const SkelectonComment = () => {
    return (
        <div>
            <div className='flex items-center'>
                <Skeleton className='h-10 w-10 rounded-full' />
                <div className='ml-2 flex flex-col'>
                    <Skeleton className='h-3 w-32' />
                    <Skeleton className='mt-2 h-3 w-10' />
                </div>
            </div>
            <Skeleton className='mt-3 h-3 w-full' />
        </div>
    )
}

const SkeletonComments = () => {
    const dataFake = Array.from({ length: 5 })
    return (
        <div className='space-y-6 pt-4'>
            {dataFake.map((_, index) => (
                <SkelectonComment key={index} />
            ))}
        </div>
    )
}

export default SkeletonComments
